import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { showRoundedAbsAmt, roundTo,
         findAbsAmtAsPct, formatMoney } from '../utils';
import { ShopperContext } from '../context/shopper';
import OrderBreakoutRow from './OrderBreakoutRow'
import { usePhrasing } from "../hooks/useSkuUtils";
import { useTranslation } from "react-i18next";
import { RiMoonLine } from "react-icons/ri";

export const GoShoppingRow = ( {
  sku,
  trip,
  tsw,
  tripShoppers,
  tripOrderItems,
  showOrderBreakout,
  tripDimSkuObj,
  tripCartSkuObj,
  skuPrice,
  skuAmtForShopper,
  skuAmtForCircle
} ) => {

  const { addTripCartSku,
          deleteTripCartSku,
          addTripDimSku,
          deleteTripDimSku,
        } = useContext(ShopperContext);

  // This sets 'checked' status upon initial open of the row:
  const [checked, setChecked] = useState(false);
  // Could do this, but above is cleaner, quickly updated by the 'useEffect':
  // const [checked, setChecked] = useState(tripCartSkuObj ? true : false);

  // This updates 'checked' status per latest 'fetchTripCartSkus'
  useEffect(() => {
    setChecked(tripCartSkuObj ? true : false);
  }, [tripCartSkuObj]);

  const { t } = useTranslation();

  const amtToGet =
    showRoundedAbsAmt({
      adjustedAbsAmtAsPct:
        findAbsAmtAsPct({topNum: skuAmtForShopper + skuAmtForCircle, sku})
    });

  const showAmtToGet =
    sku.type === "WeightyItem"
      ? (amtToGet / 100).toString() + " " + sku.units
        // 4 lb
      : roundTo({
          num: amtToGet/100,
          precision: 1
        });
        // 0.6

  const showPctToGet =
    "{" +

    (
      sku.type === "WeightyItem"
        ? Math.round(amtToGet / tsw.actual_weight).toString() + '%'
        : amtToGet + '%'
    ) +

    "}";
    // {31%}

  const maybeAddUnits =
    sku.type === "WeightyItem"
      ? "/" + sku.units
      : " " + t('sku.qty_units.each');

  const { weightAndUnitsOfSku, noDotZero } = usePhrasing();

  const handleChange = (e) => {
    const newChecked = e.target.checked;
    // console.log('newChek', newChecked);
    setChecked(newChecked);

    if (newChecked) {
      // Create a trip_cart_skus record
      try {
        addTripCartSku({
          trip_id: trip.id,
          sku_id:  sku.id,
        })
      } catch (error) {
        console.error("Error adding TCS:", error);
        setChecked(false); // rollback UI
      }
    } else {
      // Delete a trip_cart_skus record
      try {
        deleteTripCartSku(tripCartSkuObj.id)
      } catch (error) {
        console.error("Error removing TCS:", error);
        setChecked(true); // rollback UI
      }
    }
  };

  const [dimmed, setDimmed] = useState(false);

  // This updates 'dimmed' status per latest 'fetchTripDimSkus'
  useEffect(() => {
    setDimmed(tripDimSkuObj ? true : false);
  }, [tripDimSkuObj]);

  const handleClick = () => {
    const newDimmed = !dimmed;

    // console.log('newDim', newDimmed);
    setDimmed(newDimmed);

    if (newDimmed) {
      // Create a trip_dim_skus record for this trip/sku
      try {
        addTripDimSku({
          trip_id: trip.id,
          sku_id:  sku.id,
        })
      } catch (error) {
        console.error("Error adding TDS:", error);
        setDimmed(false); // rollback UI
      }
    } else {
      // Delete the trip_dim_skus record for this trip/sku
      try {
        deleteTripDimSku(tripDimSkuObj.id)
      } catch (error) {
        console.error("Error removing TDS:", error);
        setDimmed(true); // rollback UI
      }
    }
  };

  const textStyle = {
    opacity: dimmed ? 0.4 : 1, // Set opacity based on state
    transition: 'opacity 0.3s ease-in-out', // Smooth transition
  };

  // Make one-column cell that concatenates the relevant sku values for a
  // shopping list. Allows values to appear contiguously on shopper's cell
  // phone while shopping.
  // Minimal info so that shopping list is lightweight on mobile.
  return (
   <>
    <tr>
      <td style={textStyle}>
        <input
          type="checkbox"
          checked={checked}
          onChange={handleChange}
        />
        &nbsp;&nbsp;
        <span className="fw-bold">{showAmtToGet}</span>&nbsp;
        {showPctToGet}&nbsp;
        <button onClick={handleClick}>< RiMoonLine /></button>&nbsp;
        {sku.brand},&nbsp;

        <Link to={`/skus/${sku.id}?showEdit=1`}>
          {sku.label}
        </Link>,&nbsp;

        {
          formatMoney({
            amount: skuPrice,
            currency_symbol:  sku.circle.currency_symbol,
            currency_subunit: sku.circle.currency_subunit,
          })
        }{maybeAddUnits}

        {
          weightAndUnitsOfSku({
            sku,
            tsw,
            showWeightAsTswEditLink: true,
            showUnitCount: false,
            showQtyUnits: false
          })
        }
        {
          sku.type === 'MultipackItem'
            ? `, ${t('sku.qty_units.textHas')} ${noDotZero({
                                                        num: sku.unit_count})}`
            // `, has 4`
            : null
        }
      </td>
    </tr>
    {showOrderBreakout
      // Build a string showing who ordered how much of this sku
      // ui: 4.0, am: 2.5
      ? <OrderBreakoutRow
          trip           = { trip } 
          sku            = { sku } 
          tripShoppers   = { tripShoppers } 
          tripOrderItems = { tripOrderItems } 
          textStyle      = { textStyle } 
        />
      : null
    }
   </>
  )
}

export default GoShoppingRow